import { Button, Divider, Form, Tag } from 'antd';
import { useRef, useState } from 'react';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import Sticky from 'react-sticky-el';
import ModalConfirm from '../../../../components/Shared/modal/confirm';
import { EditIcon } from '../../CCTVPolicy/components/StepPreview';
import moment from 'moment';
import classNames from 'classnames';

export default function StepPreview({ forms, ...props }) {
    const { t } = useTranslation();

    const ref = useRef();

    const [openConfirm, setOpenConfirm] = useState(false);

    const { requiredInformation, documentContent } = forms;

    const _requiredInformation = {
        ...props?.previewData.requiredInformation,
        ...requiredInformation.getFieldsValue(),
    };
    const _documentContent = documentContent.getFieldsValue();

    let dpaPolicyDataSubjectType = [];

    const dsTypeGroup = _requiredInformation?.dpaPolicyDataSubjectType;

    if (dsTypeGroup) {
        const dsTypefilter = props?.dsType.filter((ds) =>
            dsTypeGroup.includes(ds.id)
        );
        dpaPolicyDataSubjectType = dsTypefilter.map((ds) => {
            return {
                dataSubjectId: ds.id,
                dataSubjectNameTh: ds.nameEn,
                dataSubjectNameEn: ds.nameTh,
            };
        });
    }

    const statusSwitch = (isPublished, isPublishedVersion) => {
        return (
            <div className="flex items-center space-x-2 mt-1">
                <div
                    className={classNames(
                        'rounded-full w-max px-3 text-xs font-medium',
                        {
                            'text-[#9A9A9A]': !isPublished,
                            'text-[#4ACE8F]': isPublished,
                        }
                    )}
                    style={
                        isPublished
                            ? {
                                  border: '1px solid #4ACE8F',
                              }
                            : {
                                  border: '1px solid #9A9A9A',
                              }
                    }
                >
                    {isPublished ? 'Published' : 'Draft'} {isPublishedVersion}
                </div>
                <span>
                    {isPublished &&
                        `${t('Published Date')} : ${
                            _requiredInformation?.publishDate
                        }`}
                </span>
            </div>
        );
    };
    const getNextVersion = () => {
        let item = '';
        let version = _requiredInformation?.latestPublishVersion;
        for (let index = 0; index <= 3; index++) {
            if (version?.split('.')[0][index] !== '0') {
                item = version
                    ?.split('.')[0]
                    ?.slice(index, version?.split('.')[0]?.length);
                break;
            }
        }
        item = String(Number(item) + 1);
        switch (item?.length) {
            case 1:
                item = '000'.concat(`${item}.0`);
                break;
            case 2:
                item = '00'.concat(`${item}.0`);
                break;
            case 3:
                item = '0'.concat(`${item}.0`);
                break;
            default:
                item = item.concat(`.0`);
                break;
        }
        return item;
    };

    const content = _documentContent?.dpaDetailDocument?.replace(
        /class="ql-align-center"/g,
        'style="text-align:center"'
    );

    let isChange = false;
    let isPublished = false;
    const version = _requiredInformation?.version || '0000.0';
    let isPublishedVersion = version;

    const parts = version?.split('.');

    if (parts && parts.length > 0) {
        const numberBehindDecimal = parseInt(parts[1]);
        const numberVersion = parseInt(parts[0]);
        if (numberVersion > 0) {
            isPublished = true;
            isPublishedVersion = parts[0] + '.0';
            if (numberBehindDecimal > 0) {
                isChange = true;
                isPublishedVersion = parts[0] + '.0';
            }
        }
    }

    return (
        <Form name="preview">
            <Sticky stickyClassName="bg-white p-4 w-full z-50">
                <div className="flex px-4">
                    <div className="flex-1">
                        <div className="text-2xl font-semibold">
                            {t('policy.des8')}
                        </div>
                        {statusSwitch(isPublished, isPublishedVersion)}
                    </div>
                    <div className="flex space-x-4">
                        <div className="text-xs text-right">
                            {_requiredInformation?.updateDate && (
                                <div>{`${t('LastUpdate')} : ${
                                    _requiredInformation?.updateDate
                                }`}</div>
                            )}
                            {isChange && (
                                <>
                                    <div>{`${t('Version')} : ${version}`}</div>
                                    <div className="text-[#F0536F]">
                                        <span className="text-xl align-middle">
                                            &bull;
                                        </span>{' '}
                                        {t('Consent.DataChanged')}
                                    </div>
                                </>
                            )}
                        </div>
                        <Button
                            type="default"
                            size="large"
                            loading={props.loadingSaveDraft}
                            onClick={props.saveDraft}
                            className="border-purple text-purple px-6"
                        >
                            {t('Save Draft')}
                        </Button>
                        <Button
                            loading={props.loading_}
                            type="primary"
                            size="large"
                            onClick={() => setOpenConfirm(true)}
                        >
                            {t('Save And Publish')}
                        </Button>
                        <button ref={ref} className="hidden" type="submit" />
                    </div>
                </div>
            </Sticky>
            <div className="px-4">
                <Divider />
                <div className="space-y-4">
                    <div>
                        <div
                            className="flex px-4 py-1 items-center mb-4"
                            style={{ background: '#F4F6FC' }}
                        >
                            <div className="flex-1 text-purple-PHX font-semibold">
                                ข้อมูลที่จำเป็นต้องระบุ
                            </div>
                            <div
                                className="mt-1 hover:opacity-80 cursor-pointer"
                                onClick={() => {
                                    props.goToStep(1);
                                }}
                            >
                                {EditIcon}
                            </div>
                        </div>
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                ชื่อสัญญาประมวลผลข้อมูลส่วนบุคคล
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {_requiredInformation?.dpaName || '-'}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                วันที่ทำสัญญาฉบับนี้
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {_requiredInformation?.contractDate
                                    ? moment(
                                          _requiredInformation?.contractDate
                                      ).format('DD/MM/YYYY')
                                    : '-'}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                ชื่อองค์กร (หรือชื่อบุคคลเจ้าของ)
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {_requiredInformation?.ownerCompanyName || '-'}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                ที่อยู่บริษัทของคุณ
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {_requiredInformation?.ownerCompanyAddress ||
                                    '-'}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                ชื่อ - นามสกุลจริง ของกรรมการหรือผู้มีอำนาจลงนาม
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {_requiredInformation?.ownerFullName || '-'}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                ชื่อตำแหน่งของกรรมการหรือผู้มีอำนาจลงนาม
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {_requiredInformation?.ownerPosition || '-'}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                ชื่อองค์กรคู่สัญญา
                                (หรือชื่อบุคคลเจ้าของคู่สัญญา)
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {_requiredInformation?.counterpartyCompanyName ||
                                    '-'}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                ที่อยู่ของบริษัทคู่สัญญา
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {_requiredInformation?.counterpartyCompanyAddress ||
                                    '-'}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                ชื่อ - นามสกุลจริง
                                ของกรรมการหรือผู้มีอำนาจลงนามของบริษัทคู่สัญญา
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {_requiredInformation?.counterpartyFullName ||
                                    '-'}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                ชื่อตำแหน่งของกรรมการหรือผู้มีอำนาจลงนามของบริษัทคู่สัญญา
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {_requiredInformation?.counterpartyPosition ||
                                    '-'}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                ชื่อสัญญาหรือโครงการที่บริษัทของคุณได้เข้าทำสัญญา
                                (รายชื่อสัญญาหลัก)
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {_requiredInformation?.mainContractName || '-'}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                ระบุความถี่ของการส่งมอบบันทึกรายการของกิจกรรมการประมวลผลข้อมูลส่วนบุคคล
                                (Record of Processing)
                                ของคู่สัญญาที่จะส่งให้ผู้ควบคุมข้อมูล
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {_requiredInformation?.frequencyForSendRopa ||
                                    '-'}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                ระบุจำนวนวันที่จะทำการลบหรือทำลายข้อมูล (วัน)
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {_requiredInformation?.amtDestroyData || '-'}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                หลังส่งมอบข้อมูลแก่คู่สัญญาแล้ว
                                มีการติดตามการใช้งานข้อมูลเป็นครั้งคราว ทุก
                                track_usage เช่น ทุก 3 เดือน 6 เดือน หรือ 1 ปี
                                เพื่อบันทึกสถานะล่าสุดในการใช้งานข้อมูลนั้น
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {_requiredInformation?.trackUsage || '-'}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                นโยบายนี้ใช้กับเจ้าของข้อมูลประเภทใด
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {dpaPolicyDataSubjectType
                                    ?.map((ds) => ds.dataSubjectNameTh)
                                    .join(', ') || '-'}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                    </div>
                    <div>
                        <div
                            className="flex px-4 py-1 items-center mb-4"
                            style={{ background: '#F4F6FC' }}
                        >
                            <div className="flex-1 text-purple-PHX font-semibold">
                                เนื้อหาเอกสาร
                            </div>
                            <div
                                className="mt-1 hover:opacity-80 cursor-pointer"
                                onClick={() => {
                                    props.goToStep(2);
                                }}
                            >
                                {EditIcon}
                            </div>
                        </div>
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                เนื้อหาเอกสารสัญญา
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="py-2 text-[#65707A]">
                                {parse(`${content || '-'}`)}
                            </div>
                            <Divider dashed className="border-t-2" />
                        </div>
                    </div>
                </div>
            </div>

            <ModalConfirm
                open={openConfirm}
                handelClose={() => setOpenConfirm(false)}
                loading={props.loading_}
                handelOk={() => {
                    if (ref.current) ref.current.click();
                }}
                title={
                    <div className="flex-column items-center text-center space-y-2">
                        <div className="font-normal text-1xl">
                            {t('Publish this policy')}
                        </div>
                        <Tag
                            className="rounded-xl text-center bg-[#7B67FB]"
                            style={{ color: '#FFFFFF', borderColor: '#FFFFFF' }}
                        >
                            {t('Consent.PublishedVersion')}:{' '}
                            {_requiredInformation?.latestPublishVersion
                                ? getNextVersion()
                                : '0001.0'}
                        </Tag>
                        <div className="font-normal text-[13px] text-[#65707A]">
                            {t('Consent.ModalDesPublish')}
                        </div>
                    </div>
                }
                text=""
            />
        </Form>
    );
}
